
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows/aluplast/[slug]",
      function () {
        return require("private-next-pages/pvc/windows/aluplast/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows/aluplast/[slug]"])
      });
    }
  